
        <a [ngClass]="'table-cell-link'" [routerLink]="[this.path, rowData.pageId]">{{renderValue}}</a>
  


// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/site/site-pages-table/page-path-cell-render.component.ts.PagePathCellRenderComponent.html